import {
  faSpinner,
  faBook,
  faUserCircle,
  faInfoCircle,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';

import {
  faBan,
  faChevronRight,
  faChevronDown,
  faDownload,
  faPowerOff,
  faSort,
  faSortDown,
  faSortUp,
  faPencil,
  faTrash,
  faPlus,
  faUndo,
  faUpload,
  faLockOpen,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faBars,
  faBatteryFull,
  faBatteryThreeQuarters,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryEmpty,
  faTimes,
  faLayerPlus,
} from '@fortawesome/pro-light-svg-icons';

const fontAwesomeIcons = [
  faBan,
  faPowerOff,
  faBars,
  faBatteryFull,
  faBatteryThreeQuarters,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryEmpty,
  faChevronRight,
  faChevronDown,
  faDownload,
  faTrash,
  faPencil,
  faLockOpen,
  faPlus,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faTimes,
  faUndo,
  faUpload,
  faUserCircle,
  faBook,
  faInfoCircle,
  faLayerPlus,
  faExclamationCircle,
];
export default fontAwesomeIcons;
